export default __webpack_public_path__ + "static/media/ic.a1e0cd88.svg";